import { useContext, useState } from "react";
import { Avatar, Stack, Box, IconButton, FormHelperText } from "@mui/material";
import ConfigContext from "../context/ConfigContext";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import EditIcon from "@mui/icons-material/Edit";

export default function ImageUpload({ initialUrl, onFileSelect, error, helperText, name }) {
    const { baseUrl } = useContext(ConfigContext);

    const getImage = (imageUrl) => {
        if (imageUrl?.startsWith("http")) return imageUrl;
        return baseUrl + imageUrl;
    };

    const [imageUrl, setImageUrl] = useState(getImage(initialUrl) || null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageUrl(reader.result);
            };
            reader.readAsDataURL(file);

            if (onFileSelect) onFileSelect(file);
        }
    };

    return (
        <Stack direction="column" alignItems="center" spacing={1}>
            <Box position="relative" display="inline-block">
                <Avatar
                    src={imageUrl || undefined}
                    sx={{ width: 100, height: 100 }}
                />
                <IconButton
                    component="label"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "rgba(255, 255, 255, 0.8)",
                        "&:hover": { bgcolor: "rgba(255, 255, 255, 1)" },
                        border: "1px solid",
                        borderColor: "grey.400",
                    }}
                    size="medium"
                >
                    {imageUrl ? <EditIcon /> : <AddAPhotoIcon />}
                    <input
                        type="file"
                        hidden
                        name={name}
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                </IconButton>
            </Box>

            {error && helperText && (
                <FormHelperText error sx={{ textAlign: "center" }}>
                    {helperText}
                </FormHelperText>
            )}
        </Stack>
    );
}
